/**
 * Created by Ivan on 24.05.2025
 */

const IncDecTutorial = function () {
    return new TutorialScenario(IncDecTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(IncDecTutorial.CONFIG)
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(IncDecTutorial.NAME);
            Game.currentGame.hand.setCards(IncDecTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(IncDecTutorial.NAME)
    });
};

IncDecTutorial.NAME = "incDecValue";
IncDecTutorial.CONFIG = {
    handValues: ["2"],
    force: "IncDecValueTutorialMessage"
};
